import { Box, Typography } from '@mui/material';
import { styled } from '@guest-widgets/core';

import { useUpsell } from '../../contexts/upsellContext/upsellContext';
import { useUpsellInSelection } from '../upsellInSelectionContext';
import ItemDeleteDialog from '../../common/ItemDeleteDialog';
import { ChipInfo } from '../../common/ChipInfo';

import { ImageWithFallback } from './ImageWithFallback';
import { DateTimeQty } from './DateTimeQty';
import { Navigation } from './Navigation';
import { useInnerDrawer } from './useInnerDrawer';

export const DateTimeLayout = () => {
  const { hasError } = useUpsell();
  const { upsellInModal, addToCartErrors, isUpsellInCart } = useUpsellInSelection();
  const {
    rateLimitError,
    addToCart,
    onOpenRemoveDialog,
    removeFromCart,
    openRemoveDialog,
    onCloseRemoveDialog,
  } = useInnerDrawer();

  const { images, name, information, totalQuantity, configuration } = upsellInModal;

  if (!Object.values(upsellInModal).length) return null;

  const { sameParentQuantity, isRequired } = configuration;
  const { body } = information?.description || {};
  const { isInCart, hasChanged } = isUpsellInCart(upsellInModal);
  const disableAddToCart =
    hasError || !totalQuantity || (sameParentQuantity && isInCart && !hasChanged);

  return (
    <Content>
      <Main>
        <Box mb={4}>
          <ImageWithFallback src={images?.[0]?.url ?? ''} alt={images?.[0]?.alt} />
        </Box>
        <Typography variant="h3" pb={sameParentQuantity ? 2 : 4}>
          {name}
        </Typography>
        <ChipInfo isInherited={sameParentQuantity} isRequired={isRequired} />
        {body && <Description variant="body1" pb={4} dangerouslySetInnerHTML={{ __html: body }} />}
      </Main>
      <Aside>
        <Box sx={{ flexGrow: 1 }}>
          <DateTimeQty item={upsellInModal} />
        </Box>
        <Navigation
          parentErrors={addToCartErrors}
          disabled={disableAddToCart}
          rateLimitError={rateLimitError}
          showRemoveButton={isInCart}
          onAddToCart={addToCart}
          onRemoveFromCart={onOpenRemoveDialog}
        />
        <ItemDeleteDialog
          open={openRemoveDialog}
          onClose={onCloseRemoveDialog}
          onConfirm={removeFromCart}
          productName={upsellInModal.name}
          rateLimitError={rateLimitError}
        />
      </Aside>
    </Content>
  );
};

const Description = styled(Typography)({
  '& p': {
    marginBlockStart: 'unset',
    marginBlockEnd: 'unset',
  },
});

const Content = styled('div')({
  display: 'flex',
  gap: 16,
  marginTop: -40,
  height: '100%',
});

const Main = styled('div')({
  width: '66%',
  maxWidth: 'calc(100% - 320px)',
});

const Aside = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '34%',
  minWidth: 320,
  position: 'sticky',
  bottom: 0,
  zIndex: 1,
  height: '100%',
});
